import {Component} from 'panel';
import {VNode} from 'snabbdom';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';
import {reporter} from 'common/report/error-reporting';

import {ToastType} from '../toast/types';
import {template} from './template';
import css from './index.inline.styl';

export const DEFAULT_TOAST_TTL = 7000;

// unique ID for every toast added
let toastID = 1;

interface ToastAreaState {
  toasts: Toast[];
}

export interface Toast {
  type?: ToastType;
  id?: number;
  cta?: string;
  ctaHref?: string;
  ctaCallback?: () => void;
  closeToastCallback?: () => void;
  elref?: string;
  hide?: boolean;
  hideCancelButton?: boolean;
  isError?: boolean;
  undoable?: boolean;
  undoLabel?: string;
  undoCallback?: () => void;
  ctaTarget?: string;
  timeout?: number;
  /* true means the toast has auto dismiss disabled */
  isStatic?: boolean;
  ttl?: number;
  message: string | VNode | VNode[];
}
export class ToastArea extends Component<ToastAreaState> {
  get config() {
    return {
      css,
      template,
      useShadowDom: true,
      defaultState: {
        toasts: [],
      },
      helpers: {
        toastAction: (toast: Toast) => {
          this.closeToast(toast);

          // TODO:  Deprecate in favor of events
          if (toast.ctaCallback) {
            toast.ctaCallback();
          }

          this.dispatchEvent(new CustomEvent(`action`, {detail: {toast}}));
        },
        toastClose: (toast: Toast) => {
          this.closeToast(toast);

          // TODO: Deprecate in favor of events
          if (toast.closeToastCallback) {
            toast.closeToastCallback();
          }

          this.dispatchEvent(new CustomEvent(`close`, {detail: {toast}}));
        },
        toastUndo: (toast: Toast) => {
          this.closeToast(toast);

          // TODO: Deprecate in favor of events
          if (toast.undoCallback) {
            toast.undoCallback();
          }

          this.dispatchEvent(new CustomEvent(`undo`, {detail: {toast}}));
        },
      },
    };
  }

  public addToast(toastAttrs: Toast): Toast {
    const newToast = {
      id: toastID++,
      timeout: DEFAULT_TOAST_TTL,
      type: ToastType.INFO,
      ...toastAttrs,
    };

    this.update({toasts: [...this.state.toasts, newToast]});

    return newToast;
  }

  public clearAllToasts() {
    this.update({toasts: []});
  }

  public closeToast(toast: Toast) {
    if (!toast) {
      reporter.warn(`Calling closeToast with null param`);
    } else {
      this.update({toasts: this.state.toasts.map((t) => (t.id === toast.id ? Object.assign(t, {hide: true}) : t))});
    }
  }
}

export const ToastAreaEl = defineAndMakeJsxFactory(`mp-toast-area`, ToastArea);
export const ToastAreaReact = panel2react(`mp-toast-area`, ToastArea);
